import { z } from 'zod';

export const SpecialKeyValidator = z.string().regex(/^[가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9]+$/gm);
export const koreanSchema = z.string().regex(/^[ㄱ-ㅎㅏ-ㅣ가-힣]+$/);
